import { tokens } from '../../../shared/styles/core/tokens';

export type FeedstockKey = 'renewable' | 'recycled' | 'nonRenewable';
export type FeedstockName = 'renewable' | 'recycled' | 'non-renewable';

interface FeedstockDefinition {
   key: FeedstockKey;
   name: FeedstockName;
   label: string;
   color: string;
}

export const FEEDSTOCKS: ReadonlyArray<FeedstockDefinition> = [
   { key: 'renewable', name: 'renewable', label: 'Renewable', color: tokens.semantic.positive },
   { key: 'recycled', name: 'recycled', label: 'Recycled', color: tokens.semantic.informative },
   { key: 'nonRenewable', name: 'non-renewable', label: 'Non-renewable', color: tokens.semantic.negative },
];

export const ALL_FEEDSTOCK_KEYS: ReadonlyArray<FeedstockKey> = FEEDSTOCKS.map((f) => f.key);

export const FEEDSTOCK_LABELS: Record<FeedstockKey, string> = Object.fromEntries(FEEDSTOCKS.map((f) => [f.key, f.label])) as Record<
   FeedstockKey,
   string
>;

export const FEEDSTOCK_COLORS: Record<FeedstockKey, string> = Object.fromEntries(FEEDSTOCKS.map((f) => [f.key, f.color])) as Record<
   FeedstockKey,
   string
>;

export const FEEDSTOCK_KEY_TO_NAME: Record<FeedstockKey, FeedstockName> = Object.fromEntries(
   FEEDSTOCKS.map((f) => [f.key, f.name])
) as Record<FeedstockKey, FeedstockName>;

export const ERROR_AUTO_DISMISS_MS = 6000;

export const YEAR_RANGE = {
   MIN: 2000,
   MAX: 2100,
} as const;

export const SHARE_RANGE = {
   MIN: 0,
   MAX: 1,
} as const;

export type MetricKey = 'share' | 'emission';